import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/dagens-spotpris/")({
  beforeLoad: () => permanentRedirect("/elpriser/idag"),
});
